"use client";

import type { HighlightedCode } from "codehike/code";
import { useState } from "react";
import { Pre } from "codehike/code";

import { cn } from "@acme/ui";

import { ScrollArea } from "../scroll-area";
import { tokenTransitions } from "./token-transition";
import { wordWrap } from "./word-wrap";

export const CodeTransition = ({
  beforeCode,
  afterCode,
  selectable,
  // index,
}: {
  beforeCode: HighlightedCode;
  afterCode: HighlightedCode;
  title: string;
  selectable?: boolean;
  index: number;
}) => {
  const [stepIndex, setStepIndex] = useState(0);
  const isBefore = stepIndex === 0;

  const setAfter = () => setStepIndex(1);
  const setBefore = () => setStepIndex(0);
  // const toggle = () => setStepIndex((i) => (i === 0 ? 1 : 0));

  // const { deselectProposedFixture, currentProposedFixturesSelection } =
  //   useFixturesStore();
  // const checked = currentProposedFixturesSelection.includes(index);

  // const handleCheckboxChange = (newValue: boolean) => {
  //   if (newValue) {
  //     useFixturesStore.setState({
  //       currentProposedFixturesSelection: [
  //         ...currentProposedFixturesSelection,
  //         index,
  //       ],
  //     });
  //   } else {
  //     deselectProposedFixture(index);
  //   }
  // };

  const heightPerLine = 20;
  const lineCount = Math.max(
    beforeCode.code.split("\n").length,
    afterCode.code.split("\n").length,
  );
  const height = lineCount * heightPerLine + 32;

  return (
    <div>
      <div
        onMouseEnter={setAfter}
        onMouseLeave={setBefore}
        className={cn(
          "group bg-background relative block w-full transition-all select-none",
          // !checked && selectable && "-translate-y-1 opacity-35",
          selectable && "cursor-pointer",
        )}
        // onClick={selectable ? () => handleCheckboxChange(!checked) : undefined}
      >
        <ScrollArea>
          <Pre
            className="bg-background rounded-lg border px-4 py-3 text-xs whitespace-pre-wrap"
            code={isBefore ? beforeCode : afterCode}
            handlers={[tokenTransitions, wordWrap]}
            style={{
              height: Math.min(height, 200),
            }}
          />
        </ScrollArea>

        {/* {selectable && (
          <Checkbox
            checked={checked}
            onCheckedChange={handleCheckboxChange}
            className="absolute bottom-2 right-2 size-6"
          />
        )} */}
      </div>
    </div>
  );
};
